var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.$style.button, ( _obj = {}, _obj[_vm.$style.disabled] = _vm.disabled, _obj )],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_c('div',{class:_vm.$style.backIcon},[_c('div',{class:_vm.$style.backCaret})]),_c('div',{class:_vm.$style.text},[_vm._v(" "+_vm._s(_vm.$t('back'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }